import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SandLandmarks } from "./sand-landmarks";

const NAVY = "#110E39";
const META = "#5a5d77";

/**
 * What a stays list shows while it loads: Sahara sand blowing in and drawing
 * a landmark, then carried off to the next (SandLandmarks), "Finding your stay",
 * and a line that turns over every two seconds. With dates it says what is
 * really happening (live prices are asked of the supplier, which takes a few
 * seconds); without, it just names the place. The cards then rise in one
 * after another (HubFade in the page).
 *
 * Motion stops under reduced motion (SandLandmarks draws one settled scene).
 */
export function StaysSearching({
  cityName,
  checkin,
  checkout,
}: {
  /** Kept for callers; the scene is the same for every property type. */
  type?: string;
  cityName?: string | null;
  checkin?: string;
  checkout?: string;
}) {
  const { t } = useTranslation();
  const place = cityName || t("stays.searching.morocco");
  const nights =
    checkin && checkout
      ? Math.max(1, Math.round((Date.parse(`${checkout}T00:00:00Z`) - Date.parse(`${checkin}T00:00:00Z`)) / 86_400_000))
      : 0;
  const lines = nights
    ? [
        t("stays.searching.live_prices", { place }),
        t("stays.searching.comparing", { count: nights }),
        t("stays.searching.almost"),
      ]
    : [t("stays.searching.loading_in", { place })];

  const [i, setI] = useState(0);
  useEffect(() => {
    if (lines.length < 2) return;
    const id = window.setInterval(() => setI((n) => (n + 1) % lines.length), 2200);
    return () => window.clearInterval(id);
  }, [lines.length]);

  return (
    <div role="status" aria-live="polite" className="flex flex-col items-center py-14 text-center">
      <SandLandmarks />
      <p className="m-0 mt-3 text-[17px] font-bold" style={{ color: NAVY }}>
        {t("stays.searching.title")}
      </p>
      {/* One line at a time, re-keyed so each fades up in turn. */}
      <p key={i} className="mj-stay-line m-0 mt-1 min-h-[20px] text-[13.5px]" style={{ color: META }}>
        {lines[i % lines.length]}
      </p>
    </div>
  );
}
